<!-- 评价指标初高 -->
<template>
  <div style="width: 100%; height: 100%">
    <div class="header">
      <span>应用／综合评价／评价指标（{{ higherName }}）</span>
    </div>
    <div class="main-content-inner">
      <div style="text-align: center">
        <el-radio-group v-model="type" size="medium" @change="changeType">
          <el-radio-button label="评价指标"></el-radio-button>
          <el-radio-button label="计分规则"></el-radio-button>
          <el-radio-button label="报告模板"></el-radio-button>
        </el-radio-group>
      </div>
      <!-- 评价指标 -->
      <div v-if="type === '评价指标'" class="first-standard-container">
        <div class="first-standard scroll">
          <span>一级指标</span>
          <span class="edit-button" v-if="!editFirstStandard">
            <el-button
              v-if="standards.length !== 0"
              type="primary"
              size="medium"
              plain
              @click="editStandard"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="medium"
              plain
              :disabled="standards.length === 10"
              @click="addFirstStandard"
              >+ 添加一级指标</el-button
            >
          </span>
          <span class="edit-sure-button" v-else>
            <el-button
              type="primary"
              size="medium"
              plain
              @click="cancelEditStandard"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="medium"
              @click="confirmFirstStandard"
              >确定</el-button
            >
          </span>
          <div class="standard-container" v-if="!editFirstStandard">
            <el-button
              v-for="item in standards"
              :key="item.id"
              :class="activeStandard === item.id ? 'actived' : ''"
              type="primary"
              size="medium"
              plain
              @click="clickStandard(item)"
              >{{ item.name }}</el-button
            >
          </div>
          <div class="standard-container" v-else>
            <div
              v-for="(item, index) in standards"
              :key="item.value"
              style="display: inline-block; position: relative"
            >
              <el-input
                v-model.trim="item.name"
                :maxlength="10"
                clearable
                @clear="clearStandard(item, index)"
              ></el-input>
              <span
                v-if="item.err"
                style="
                  position: absolute;
                  top: 30px;
                  left: 5px;
                  transition: all 1s ease-out;
                  color: #ed4014;
                  font-size: 12px;
                "
                >{{ item.errorMsg }}</span
              >
            </div>
          </div>
          <div style="padding: 20px">
            <el-row :gutter="24" type="flex" align="middle">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{
                    firstStandardName
                  }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >评价要点配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span class="edit-second-button">
                  <el-button
                    v-if="standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="addJudge"
                    >+ 添加评价要点</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="judgeData"
                  size="medium"
                  border
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="name"
                    label="二级指标名称"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="pointsContent"
                    label="评价要点"
                  ></el-table-column>
                  <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        @click="handleEditJudge(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        @click="handleDeleteJudge(scope.$index, scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
          <div style="margin-top: 25px; padding: 20px">
            <el-row :gutter="24" type="flex" align="middle">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{
                    firstStandardName
                  }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >记录要点配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span class="edit-second-button" v-if="!scoreSetting">
                  <el-button
                    v-if="standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="setScore"
                    >分值权重设置</el-button
                  >
                  <el-button
                    v-if="standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="addReport"
                    >+ 添加记录要点</el-button
                  >
                </span>
                <span class="edit-second-sure-button" v-else>
                  <el-button
                    type="primary"
                    size="medium"
                    plain
                    @click="cancelSetScore"
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="medium"
                    @click="confirmScoreSet"
                    >确定</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="recordData"
                  size="medium"
                  key="recordData"
                  border
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="indicatorPoint"
                    label="记录要点"
                    min-width="400"
                  ></el-table-column>
                  <el-table-column label="分值权重" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.add">-</span>
                      <span v-else>
                        <span v-if="!scope.row.editScore">{{
                          scope.row.scoreRatio
                        }}</span>
                        <el-input-number
                          v-else-if="scope.row.editScore"
                          type="textarea"
                          :id="'record-score' + scope.$index"
                          :min="0"
                          :max="100"
                          :step="1"
                          :step-strictly="true"
                          v-model.trim="scope.row.scoreRatio"
                          :controls="false"
                        ></el-input-number>
                        <span>分</span>
                        <span
                          v-if="scope.row.editScoreError"
                          style="color: #ed4014; font-size: 12px"
                          >指标名称已存在</span
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计分规则"
                    prop="scoringRuleConfigContent"
                    width="300"
                  >
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        :disabled="scoreSetting"
                        type="text"
                        @click="handleEditReport(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        :disabled="scoreSetting"
                        type="text"
                        @click="handleDeleteReport(scope.$index, scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 计分规则 -->
      <div v-if="type === '计分规则'" class="first-standard-container">
        <div class="first-standard scroll">
          <span>计分规则</span>
          <div class="standard-container">
            <el-button
              v-for="item in rules"
              :key="item.type"
              :class="activeRule === item.id ? 'actived' : ''"
              type="primary"
              size="medium"
              plain
              @click="clickRule(item)"
              >{{ item.name }}</el-button
            >
          </div>
          <div style="margin-top: 25px; padding: 20px">
            <el-row :gutter="24" type="flex" align="middle">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{ ruleName }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >得分规则配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span class="edit-second-button">
                  <el-button
                    v-if="activeRule !== lastRule"
                    type="primary"
                    size="medium"
                    plain
                    @click="addRule"
                    >+ 添加得分规则</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="ruleData"
                  size="medium"
                  key="ruleData"
                  border
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="ruleConfigName"
                    label="规则名称"
                    width="200"
                  ></el-table-column>
                  <el-table-column label="规则说明">
                    <template slot-scope="scope"
                      ><span class="text-wrapper">{{
                        scope.row.ruleDec
                      }}</span></template
                    ></el-table-column
                  >
                  <el-table-column
                    v-if="activeRule !== lastRule"
                    fixed="right"
                    label="操作"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        @click="handleEditRule(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 报告模板 -->
      <div v-if="type === '报告模板'" class="report-standard-container">
        <div class="first-standard scroll">
          <el-tabs
            v-model="activeReport"
            class="zyyj-tabs-custom"
            @tab-click="changeReport"
          >
            <el-tab-pane label="学期报告" name="term">
              <!-- <component :is="termTemplate" :dimension="dimension"></component> -->
              <!-- <component
                :is="termTemplate"
                :dimension="dimension"
                :student="{ studentId, schoolTermId: detail.schoolTermId }"
              ></component> -->
              <quality-evaluation-term-report
                :student="{ studentId, schoolTermId: detail.schoolTermId }"
                :dimension="dimension"
              >
              </quality-evaluation-term-report>
            </el-tab-pane>
            <!-- <el-tab-pane label="毕业报告" name="graduate">
              <component :is="graduateTemplate" :dimension="dimension"></component>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </div>
    <add-first-standard
      :visible.sync="standardVisible"
      :identify="id"
      @edit-result="initStandard()"
    ></add-first-standard>

    <add-judge-point
      :visible.sync="judgePointVisible"
      :identify="judgePointInfo"
      @edit-result="initRecord()"
    ></add-judge-point>

    <add-report-point
      :visible.sync="reportPointVisible"
      :identify="reportPointInfo"
      @edit-result="initRecord()"
    ></add-report-point>

    <add-realistic-record
      :visible.sync="realisticRecordVisible"
      :identify="realisticRecordInfo"
      @edit-result="initRuleConfig(activeRule)"
    ></add-realistic-record>

    <add-reward
      :visible.sync="rewardVisible"
      :identify="rewardInfo"
      @edit-result="initRuleConfig(activeRule)"
    ></add-reward>

    <add-level-score
      :visible.sync="levelScoreVisible"
      :identify="levelScoreInfo"
      @edit-result="initRuleConfig(activeRule)"
    ></add-level-score>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import AddFirstStandard from '@/components/common/AddFirstStandard'
import AddJudgePoint from '@/components/common/AddJudgePoint'
import AddReportPoint from '@/components/common/AddReportPoint'
import AddRealisticRecord from '@/components/common/AddRealisticRecord'
import AddReward from '@/components/common/AddReward'
import AddLevelScore from '@/components/common/AddLevelScore'
import QualityEvaluationTermReport from '@/components/common/student-status-card/QualityEvaluationTermReportStatic'

export default {
  props: ['id'],

  components: {
    'second-nav-bar': SecondNavBar,
    'add-first-standard': AddFirstStandard,
    'add-judge-point': AddJudgePoint,
    'add-report-point': AddReportPoint,
    'add-realistic-record': AddRealisticRecord,
    'add-reward': AddReward,
    'add-level-score': AddLevelScore,
    'quality-evaluation-term-report': QualityEvaluationTermReport
  },

  data () {
    return {
      type: '评价指标',
      editFirstStandard: false,
      activeStandard: '',
      standards: [],
      clonedStandards: [],
      judgeData: [],
      scoreSetting: false,
      recordData: [],
      clonedRecordData: [],
      rules: [],
      activeRule: 1,
      ruleData: [],
      standardVisible: false,
      judgePointVisible: false,
      reportPointVisible: false,
      realisticRecordVisible: false,
      rewardVisible: false,
      levelScoreVisible: false,
      judgePointInfo: {},
      reportPointInfo: {},
      realisticRecordInfo: {},
      rewardInfo: {},
      levelScoreInfo: {},
      activeReport: 'term',
      dimension: {},
      levels: [
        {
          name: '省级',
          value: 1
        },
        {
          name: '市级',
          value: 2
        },
        {
          name: '区县级',
          value: 3
        },
        {
          name: '校级',
          value: 4
        }
      ],
      ruleOptions: [],
      // termTemplate: null,
      graduateTemplate: null,
      studentId: null,
      detail: {
        schoolTermId: null
      }
    }
  },

  watch: {
    $route: {
      handler: function (val) {
        Object.assign(this.$data, this.$options.data())
      },
      deep: true
    }
  },

  computed: {
    _ () {
      return _
    },
    firstStandardName () {
      let firstStandard = _.filter(
        this.editFirstStandard ? this.clonedStandards : this.standards,
        { id: this.activeStandard }
      )[0]
      return firstStandard && firstStandard.name
    },
    firstStandardValue () {
      let firstStandard = _.filter(
        this.editFirstStandard ? this.clonedStandards : this.standards,
        { id: this.activeStandard }
      )[0]
      return firstStandard && firstStandard.id
    },
    ruleName () {
      let rule = _.filter(this.rules, { id: this.activeRule })[0]
      return rule && rule.name
    },
    lastRule () {
      return this.rules.length > 0 && this.rules[this.rules.length - 1].id
    },
    higherName () {
      let plan = JSON.parse(sessionStorage.getItem('plans'))
      return plan[0].schoolStage === 2 ? '初中' : '高中'
    }
  },

  mounted () {
    this.initStandard()
    this.initRuleOption()
  },

  destroyed () {
    sessionStorage.removeItem('plans')
  },

  methods: {
    initStandard () {
      this.initJudge()
    },

    initJudge () {
      this.$xhrGet(`/eval/indicators/primary/list/${this.id}`).then(rs => {
        this.standards = rs.data
        if (rs.data.length !== 0) {
          this.activeStandard = rs.data[0].id
          this.initRecord()
        } else {
          this.judgeData = []
          this.recordData = []
        }
      })
    },

    initRecord () {
      this.$xhrGet(
        `/eval/indicators/secondary/list/${this.activeStandard}`
      ).then(rs => {
        this.judgeData = rs.data
      })
      this.$xhrGet(`/eval/indicators/config/list/${this.activeStandard}`).then(
        rs => {
          this.recordData = rs.data
        }
      )
    },

    initRuleOption () {
      let plan = JSON.parse(sessionStorage.getItem('plans'))
      this.$xhrGet(`/eval/indicators/scoring-rule/${plan[0].schoolStage}`).then(
        rs => {
          this.rules = rs.data
          this.activeRule = rs.data[0].id
          this.initRuleConfig(rs.data[0].id)
        }
      )
      this.$xhrGet(
        `/eval/indicators/scoring-rule-config/stage/${plan[0].schoolStage}`
      ).then(rs => {
        this.ruleOptions = rs.data
      })
    },

    initRule () {
      let plan = JSON.parse(sessionStorage.getItem('plans'))
      this.$xhrGet(`/eval/indicators/scoring-rule/${plan[0].schoolStage}`).then(
        rs => {
          this.rules = rs.data
          this.activeRule = rs.data[0].id
          this.initRuleConfig(rs.data[0].id)
        }
      )
    },

    initRuleConfig (rule) {
      let param = {
        ruleId: rule
      }
      this.$xhrGet(`/eval/indicators/scoring-rule-config`, param).then(rs => {
        this.ruleData = rs.data
      })
    },

    async initTemplate () {
      let plan = JSON.parse(sessionStorage.getItem('plans'))[0]
      let stageName = plan.schoolStage === 2 ? '初中' : '高中'
      let dimension = []
      dimension = { stageName: stageName, indicatorsItemList: [] }
      let clonedStandards = _.cloneDeep(this.standards)
      for (let index = 0; index < clonedStandards.length; index++) {
        let element = clonedStandards[index]
        dimension.indicatorsItemList[index] = {
          indicatorsName: element.name,
          indicatorsScore: ''
        }
      }
      // 根据配置信息显示不同模板
      setTimeout(() => {
        this.studentId = Math.random()
        this.detail.schoolTermId = Math.random()
        this.dimension = dimension
      }, 100)
      // this.termTemplate = (await import('../../common/HengShuiTemplate')).default
    },

    changeType (val) {
      switch (val) {
        case '评价指标':
          this.initStandard()
          this.initRuleOption()
          break
        case '计分规则':
          this.initRule()
          break
        case '报告模板':
          this.initTemplate()
          break
        default:
          this.initStandard()
          this.initRuleOption()
      }
    },

    editStandard () {
      this.clonedStandards = _.cloneDeep(this.standards)
      this.editFirstStandard = true
    },

    addFirstStandard () {
      this.standardVisible = true
    },

    cancelEditStandard () {
      this.editFirstStandard = false
      this.standards = this.clonedStandards
    },

    confirmFirstStandard () {
      let firstStandard = _.filter(this.standards, { name: '' })[0]
      if (firstStandard) {
        this.$set(firstStandard, 'err', true)
        this.$set(firstStandard, 'errorMsg', '指标名称不得为空')
        return false
      }
      let names = _.map(this.standards, 'name')
      let uniqNames = _.uniq(names)
      if (names.length !== uniqNames.length) {
        this.$message.error('指标名称已存在')
        return false
      }
      this.$xhrPost(
        `/eval/indicators/primary/list/${this.id}/save`,
        this.standards
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.editFirstStandard = false
          this.initStandard()
          this.initRuleOption()
        } else {
          let firstStandard = _.filter(this.standards, { value: rs.data })[0]
          if (firstStandard) {
            this.$set(firstStandard, 'err', true)
            this.$set(firstStandard, 'errorMsg', '指标名称已存在')
            return false
          }
        }
      })
    },

    clickStandard (item) {
      this.activeStandard = item.id
      this.editFirstStandard = false
      this.scoreSetting = false
      this.initRecord()
    },

    clearStandard (item, index) {
      this.standards.splice(index, 1)
    },

    addJudge () {
      this.judgePointVisible = true
      this.judgePointInfo = {}
      this.$set(this.judgePointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    handleEditJudge (index, row) {
      this.judgePointVisible = true
      this.judgePointInfo = row
      this.$set(this.judgePointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    handleDeleteJudge (index, row) {
      this.$xhrDelete(
        `/eval/indicators/secondary/${this.activeStandard}/${row.id}`
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initRecord()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    },

    setScore () {
      this.scoreSetting = true
      this.clonedRecordData = _.cloneDeep(this.recordData)
      this.recordData = this.recordData.map(row => {
        return {
          ...row,
          editScore: true
        }
      })
      this.$nextTick(() => {
        let el = document.getElementById('record-score0')
        el.focus()
      })
    },

    addReport () {
      this.reportPointVisible = true
      this.reportPointInfo = {}
      this.$set(this.reportPointInfo, 'rules', _.cloneDeep(this.rules))
      this.$set(this.reportPointInfo, 'ruleOpt', _.cloneDeep(this.ruleOptions))
      this.$set(this.reportPointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    cancelSetScore () {
      this.scoreSetting = false
      this.recordData = this.clonedRecordData
    },

    confirmScoreSet () {
      let totalScore = _.sum(_.map(this.recordData, 'scoreRatio'))
      if (totalScore !== 100) {
        this.$message.error('当前分值权重总和不等于100，请重新设置')
        return false
      }
      this.$xhrPut(
        `/eval/indicators/config/score-set/${this.activeStandard}`,
        this.recordData
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.scoreSetting = false
          this.initRecord()
        }
      })
    },

    handleEditReport (index, row) {
      this.reportPointVisible = true
      this.reportPointInfo = row
      this.$set(this.reportPointInfo, 'rules', _.cloneDeep(this.rules))
      this.$set(this.reportPointInfo, 'ruleOpt', _.cloneDeep(this.ruleOptions))
      this.$set(this.reportPointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    handleDeleteReport (index, row) {
      this.$xhrDelete(
        `/eval/indicators/config/${this.activeStandard}/${row.id}`
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initRecord()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    },

    clickRule (item) {
      this.activeRule = item.id
      this.initRuleConfig(this.activeRule)
    },

    addRule () {
      let checkedRule = _.filter(this.rules, { id: this.activeRule })[0].type
      if (checkedRule === 1) {
        this.realisticRecordVisible = true
        this.realisticRecordInfo = {}
        this.$set(this.realisticRecordInfo, 'scoreArr', [])
        this.$set(this.realisticRecordInfo, 'time', 0)
        this.$set(this.realisticRecordInfo, 'ruleConfigId', this.activeRule)
        this.$set(
          this.realisticRecordInfo,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
      } else if (checkedRule === 2) {
        let clonedRow = {}
        let score = []
        for (let index = 0; index < 4; index++) {
          score.push({
            name: _.filter(this.levels, { value: index + 1 })[0].name,
            value: index + 1,
            score: [],
            times: null
          })
        }
        this.$set(clonedRow, 'scoreArr', score)
        this.$set(
          clonedRow,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
        this.rewardInfo = clonedRow
        this.rewardVisible = true
      } else if (checkedRule === 3) {
        let clonedRow = {}
        let score = []
        for (let index = 0; index < 4; index++) {
          score.push({
            level: index + 1,
            score: index === 0 ? 100 : 0
          })
        }
        this.$set(clonedRow, 'scoreArr', score)
        this.$set(
          clonedRow,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
        this.levelScoreInfo = clonedRow
        this.levelScoreVisible = true
      }
    },

    handleEditRule (index, row) {
      let checkedRule = _.filter(this.rules, { id: this.activeRule })[0].type
      if (checkedRule === 1) {
        this.$xhrGet(`/eval/indicators/scoring-rule-config/${row.id}`).then(
          rs => {
            let score = _.cloneDeep(rs.data.content[0].itemDetailList)
            let clonedRow = _.cloneDeep(row)
            this.$set(clonedRow, 'scoreArr', score)
            this.$set(clonedRow, 'time', score.length)
            this.$set(clonedRow, 'ruleConfigId', row.id)
            this.$set(
              clonedRow,
              'ruleInfo',
              _.filter(this.rules, { id: this.activeRule })[0]
            )
            this.realisticRecordInfo = clonedRow
            this.realisticRecordVisible = true
          }
        )
      } else if (checkedRule === 2) {
        let clonedRow = {}
        let score = []
        this.$xhrGet(`/eval/indicators/scoring-rule-config/${row.id}`).then(
          rs => {
            let contentArr = _.cloneDeep(rs.data.content)
            for (let index = 0; index < contentArr.length; index++) {
              let ele = contentArr[index]
              score.push({
                name: _.filter(this.levels, { value: ele.level })[0].name,
                value: ele.level,
                score: !ele.itemDetailList ? [] : ele.itemDetailList,
                times: !ele.recordCount ? null : ele.recordCount
              })
            }
          }
        )
        this.$set(clonedRow, 'scoreArr', score)
        this.$set(clonedRow, 'ruleConfigId', row.id)
        this.$set(
          clonedRow,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
        this.rewardInfo = clonedRow
        this.rewardVisible = true
      } else if (checkedRule === 3) {
        this.$xhrGet(`/eval/indicators/scoring-rule-config/${row.id}`).then(
          rs => {
            let score = _.cloneDeep(rs.data.content)
            if (rs.data.content.length < 5) {
              for (
                let index = rs.data.content.length;
                index < 5 - rs.data.content.length;
                index++
              ) {
                score.push({
                  level: index + 1,
                  score: 0
                })
              }
            }
            let clonedRow = _.cloneDeep(row)
            this.$set(clonedRow, 'scoreArr', score)
            this.$set(clonedRow, 'ruleConfigId', row.id)
            this.$set(
              clonedRow,
              'ruleInfo',
              _.filter(this.rules, { id: this.activeRule })[0]
            )
            this.levelScoreInfo = clonedRow
            this.levelScoreVisible = true
          }
        )
      }
    },

    changeReport (tab) {
      this.initTemplate()
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content-inner {
  float: right;
  height: calc(100% - 88px);
  width: calc(100% - 40px);
  padding: 20px;
  position: relative;
  background: var(--theme-background);
}
.main-content /deep/ .el-radio-button__inner {
  background: transparent;
  color: #606266;
}
.main-content /deep/ .is-active .el-radio-button__inner {
  background: var(--theme-color);
  color: #ffffff;
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #757575;
}
.first-standard-container {
  height: calc(100% - 96px);
  margin-top: 20px;
}
.first-standard {
  height: auto;
  max-height: 100%;
  padding: 20px;
  border-radius: 4px;
  overflow-y: scroll;
  background: #fff;
}
.edit-button /deep/ .el-button--primary.is-plain {
  background: transparent;
}
.edit-button /deep/ .el-button.is-plain:hover {
  color: var(--theme-color);
}
.edit-button /deep/ .el-button.is-plain:focus {
  color: var(--theme-color);
}
.edit-button {
  display: inline-block;
  width: calc(100% - 70px);
  text-align: right;
}
.edit-sure-button {
  display: inline-block;
  width: calc(100% - 70px);
  text-align: right;
}
.edit-sure-button /deep/ .el-button--primary.is-plain {
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.standard-container {
  margin-top: 15px;
  line-height: 60px;
}
.standard-container /deep/ .el-button + .el-button {
  margin-left: 0;
}
.standard-container /deep/ .el-button--primary.is-plain {
  min-width: 120px;
  margin-right: 20px;
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.standard-container /deep/ .el-button--primary.is-plain.actived {
  min-width: 120px;
  margin-right: 20px;
  background: #eeeefd;
  color: var(--theme-color);
  border-color: var(--theme-color);
}
.standard-container .el-input {
  max-width: 220px;
  margin-right: 20px;
}
.edit-second-button {
  display: inline-block;
  width: calc(100% - 180px);
  text-align: right;
}
.edit-second-button /deep/ .el-button--primary.is-plain {
  background: transparent;
}
.edit-second-button /deep/ .el-button.is-plain:hover {
  color: var(--theme-color);
}
.edit-second-button /deep/ .el-button.is-plain:focus {
  color: var(--theme-color);
}
.edit-second-sure-button {
  display: inline-block;
  width: calc(100% - 180px);
  text-align: right;
}
.edit-second-sure-button /deep/ .el-button--primary.is-plain {
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.el-table--border {
  border-radius: 4px;
}
.el-input-number {
  width: 55px;
}
.report-standard-container {
  height: calc(100% - 91px);
  margin-top: 20px;
}
.text-wrapper {
  white-space: pre-wrap;
}
/deep/ .el-table tbody tr td {
  padding: 0 !important;
}
/deep/ .el-tab-pane {
  table > tbody > tr td {
    text-align: center !important;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/apply/ViewHigherTarget.vue